// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import SimpleSelectController from "./simple_select_controller"
application.register("simple-select", SimpleSelectController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

// Wikifarm controllers
import WikiEditorController from "./wiki_editor_controller"
application.register("wiki-editor", WikiEditorController)

import NavEditorController from "./nav_editor_controller"
application.register("nav-editor", NavEditorController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import BulkUploadController from "./bulk_upload_controller"
application.register("bulk-upload", BulkUploadController)

import TagSuggestionsController from "./tag_suggestions_controller"
application.register("tag-suggestions", TagSuggestionsController)

import FestivalScheduleController from "./festival_schedule_controller"
application.register("festival-schedule", FestivalScheduleController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import UiPaletteEditorController from "./ui_palette_editor_controller"
application.register("ui-palette-editor", UiPaletteEditorController)
